// extracted by mini-css-extract-plugin
export var container = "edge_of_possible-module--container--3h1eg";